import React, { Component } from 'react'

import * as LocationActions from '../../actions/LocationActions'
import * as GeometryActions from '../../actions/GeometryActions'

class ResultItem extends Component {
  constructor(props) {
    super(props)

    // Bind events
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    // Create new google.maps.LatLng instance
    let geometry = new window.google.maps.LatLng(
      this.props.data.Latitude,
      this.props.data.Longitude
    )

    // Fire Geometry action
    GeometryActions.change(geometry)
    LocationActions.setSelectedSearchResult(this.props.data.Id)
  }

  render() {
    return (
      <div className="c-location-finder__result" onClick={this.handleClick}>
        <div className="c-location-finder__result__inner">
          <p className="c-location-finder__result__name">
            {this.props.data.Name}
          </p>
          {this.props.data.Distance && (
            <p className="c-location-finder__result__distance">
              {this.props.data.Distance.toFixed(1)
                .toString()
                .replace('.', ',')}{' '}
              km
            </p>
          )}
          <i
            className={`c-location-finder__result__icon ${
              this.props.data.OfficeType.Icon
            }`}
          />
        </div>
      </div>
    )
  }
}

export default ResultItem
